import React, { useRef, useState } from 'react';
import { Select } from 'antd';
import config from './config';
import dayjs from 'dayjs';
import AddOrEdit from './AddOrEdit';
import { SActionBtn, SLowcodeList, STableActions } from 'shj-components';
import { changeStatusFn, delFn, fetchList, getCompanyFn, getDept, getProductionType } from './funs';
import { getCategoryFn } from '../Company/funs';
import {
  getAllCompanyMrn,
  httpAchievementDateList,
  httpAchievementPersonalDeptPersionDetails
} from '@/services/customerServices';
import { getUser } from '@/common/utils.ts'

const { Option } = Select;
interface IPersonalProps {

}
const Personal: React.FC<IPersonalProps> = () => {
  const userInfo: any = getUser();
  const compony = useRef<any>([]);
  const category = useRef<any>([]);
  const dept = useRef<any>([]);
  const listRef = useRef<any>();
  const [yearMonthArr, setMonthYearArr] = useState<any[]>([]);
  const [id, setId] = useState<number | undefined>(undefined);
  const [editData, setEditData] = useState<any>({});
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  /**
   * 新增
   */
  const onAdd = () => {
    setId(undefined);
    setIsVisible(true);
    setEditData({});
  };

  /**
   * 列表 - 获取统一配置数据集合
   * @returns 
   */
  const getSelect = () => {
    return new Promise( (resolve) => {
      Promise.all([
        getCompanyFn(compony),
        getProductionType(),
        getCategoryFn(category),
        getDept(userInfo && userInfo?.companyId && [userInfo?.companyId]),
        getAllCompanyMrn({ directlyUnder: { orgId: userInfo?.orgId, includeChild: true } })
      ]).then((result: any) => {
        dept.current = result[4];
        resolve({
          company: result[0],
          productType: result[1],
          category: result[2],
          dept: result[3],
        });
      });
    });
  };

  /**
   * 编辑
   * @param record 
   * @param check 
   */
  const onEdit = (record: any, check: boolean) => {
    setId(record.id);
    setIsVisible(true);
    setLoading(true)
    httpAchievementPersonalDeptPersionDetails(record.id).then((resp) => {
      setEditData({ ...resp, check });
    }).finally(() => setLoading(false));
  };

  /**
   * 根据公司、部门变化获取相关下拉数据
   */
  const onSelectChange = () => {
    const _category = listRef.current.getSearch().getFieldValue('category');
    let _companyId = listRef.current.getSearch().getFieldValue('companyCode');
    listRef.current.getSearch()?.setFieldsValue({yearMonth: undefined})
    console.log(listRef.current.getSearch());
    
    if (_category && _companyId) {
      compony.current[0].child.map((item: any) => {
        if (item.code == _companyId) {
          _companyId = item.id;
        }
      });
      httpAchievementDateList({
        category: _category,
        companyId: _companyId,
      }).then((resp: any) => {
        setMonthYearArr(resp || []);
      });
    }
  };

  /** 获取年月日变化设置年月 */
  const selectChange = (v: any) => {
    listRef.current.getSearch().setFieldsValue({ yearMonth: v });
  };

  const extension = {
    request: { fetchList, getSelect },
    events: { onAdd, onSelectChange },
    customRender: {
      selectRender() {
        return (
          <Select placeholder="请选择" allowClear onChange={(v) => selectChange(v)} disabled={!yearMonthArr.length}>
            {yearMonthArr.map((item: any, index: number) => {
              return (
                <Option
                  key={index}
                  value={
                    item.year ? dayjs(item.year + '-' + item.month, 'YYYY-MM').format('YYYY-MM') + '*' + item.id : ''
                  }
                >
                  {item.year ? dayjs(item.year + '-' + item.month, 'YYYY-MM').format('YYYY-MM') : '时间格式出错'}
                </Option>
              );
            })}
          </Select>
        );
      },
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            {record.status == 'DRAFT' || record.status == 'REJECT' ? (
              <React.Fragment>
                <SActionBtn onClick={() => onEdit(record, false)}>编辑</SActionBtn>
                <SActionBtn confirm title="确认提交吗？" onClick={() => changeStatusFn(record, 'PENDING', listRef)}>提交</SActionBtn>
                <SActionBtn confirm title="确认删除吗？" onClick={() => delFn(record, listRef)}>删除</SActionBtn>
              </React.Fragment>
            ) : null}
            {record.status == 'PENDING'
              ?
              <React.Fragment>
                <SActionBtn confirm title="确认通过吗？" onClick={() => changeStatusFn(record, 'CONFIRM', listRef)}>通过</SActionBtn>
                <SActionBtn confirm title="确认驳回吗？" onClick={() => changeStatusFn(record, 'REJECT', listRef)}>驳回</SActionBtn>
              </React.Fragment>

              : null}
            {record.status == 'CONFIRM' ? <SActionBtn onClick={() => onEdit(record, true)}>查看</SActionBtn> : null}
          </STableActions>
        );
      },
      nameAddWorkNumber(text: any, record: any) {
        return `${record.personalName}{${record.personalWorkNumber}}`;
      },
    },
  };
  return (
    <>
      <SLowcodeList config={config} ref={listRef} {...extension} />
      <AddOrEdit
          loading={loading}
        editData={editData}
        id={id}
        setVisible={setIsVisible}
        visible={isVisible}
        listRef={listRef}
        deptRef={dept}
      />
    </>
  );
};

export default Personal;
